import { Flex, Typography } from "@qws-org/ui-kit";
import type { FC } from "react";

import type { MainBannerV2Props } from "../MainBannerV2";

export const MainBannerRowItems: FC<MainBannerV2Props> = ({ data }) => {
  return (
    <Flex
      m={{ mb: 32 }}
      md={{ maxWidth: 610, m: { mb: 60 } }}
      as="ul"
      flexDirection="column"
      align="stretch"
    >
      {data?.items?.map((item) => (
        <Typography
          key={item.id}
          as="li"
          horizontalAlign="center"
          size="medium"
          md={{
            fontSize: "button.desktop.medium",
            lineHeight: "button.desktop.medium",
            horizontalAlign: "left",
          }}
        >
          {item?.main_banner_items_id?.text}
        </Typography>
      ))}
    </Flex>
  );
};
